import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import Button from 'flarum/common/components/Button';
import IgnoreDiscussionModal from './components/IgnoreDiscussionModal';
import UnignoreDiscussionModal from './components/UnignoreDiscussionModal';
export default function () {
  extend(DiscussionControls, 'userControls', function (items, discussion) {
    if (!app.session.user) {
      return;
    }
    function unignore() {
      app.modal.show(UnignoreDiscussionModal, {
        discussion
      });
    }
    function ignore() {
      app.modal.show(IgnoreDiscussionModal, {
        discussion
      });
    }
    if (discussion.ignored()) {
      items.add('unignore-discussion', m(Button, {
        icon: "fas fa-eye",
        onclick: unignore
      }, app.translator.trans('bizkaitarra-ignore-users.forum.discussion_controls.unignore_button')), -10);
    } else {
      items.add('ignore-discussion', m(Button, {
        icon: "fas fa-eye-slash",
        onclick: ignore
      }, app.translator.trans('bizkaitarra-ignore-users.forum.discussion_controls.ignore_button')), -10);
    }
  });
}